import { Typography } from '@mui/material'
import React from 'react'
import CouponConfigurableLabel from '../CouponConfigurableLabel';

function ValidationContent({validationErrors}:{validationErrors:{
    label: string;
    data: string;
}[]}) {
  
    return (
    <div className='validation-content-wrapper'>
        {
            validationErrors.map((item:{label:string , data:string},id:number)=>{
               return <div className='validation-single-content' key={id} style={{display:'flex',flexDirection:'column',gap:'10px',margin:'20px'}}>
                    <div className="validation-single-content" style={{display:'flex',gap:'10px'}}>
                        <div className="" style={{ width:'40%'}}>
                            <CouponConfigurableLabel text={item.label} style={{fontSize:'1.2rem'}}/>
                        </div>
                        
                        <span style={{marginRight:'10px'}}>:</span>

                        <div style={{flex:1}}> 
                           <Typography variant='subtitle1' sx={{ color: 'indianred', display: 'inline'}}>
                               {item.data}
                           </Typography>
                        </div>

                    </div>

                </div>
            })
        }
    </div>
  )
}

export default ValidationContent